import React from 'react';
import { Link } from 'react-router-dom';

const RecentVendors = ({ vendors, todayVendors }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-3 border-b border-gray-200 flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">Recent Vendors</h3>
        <span className="text-xs text-gray-600 flex items-center">
          <i className="bi bi-person-check-fill mr-2" style={{ color: '#009ef7' }}></i>
          {todayVendors || 0} Vendors today
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs sm:text-sm">
          <thead className="bg-gray-50 text-gray-600 text-xs uppercase font-semibold border-b border-gray-200">
            <tr>
              <th className="px-3 py-3 text-left">Vendor Details</th>
              <th className="px-5 py-3 text-left">Address</th>
              <th className="px-5 py-3 text-left">Date</th>
            </tr>
          </thead>
          <tbody className="text-gray-800 font-medium">
            {vendors && vendors.length > 0 ? (
              vendors.map((vendor) => (
                <tr key={vendor._id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-3 py-4">
                    <div className="flex items-center">
                      <img
                        src={vendor.image ? `${process.env.REACT_APP_MEDIA_URL}${vendor.image}` : '/assets/media/avatars/300-1.jpg'}
                        alt={vendor.first_name}
                        className="w-16 h-16 rounded-full object-cover mr-3"
                        onError={(e) => {
                          e.target.src = '/assets/media/avatars/300-1.jpg';
                        }}
                      />
                      <div>
                        <Link
                          to={`/vendor/edit/${vendor._id}`}
                          className="font-semibold no-underline block"
                          style={{ color: '#009ef7' }}
                        >
                          {vendor.business_name || '-'}
                        </Link>
                        <div className="text-sm text-gray-600 mt-1">
                          <div>{vendor.first_name || '-'}</div>
                          <div>{vendor.email || '-'}</div>
                          <div>{vendor.phone || '-'}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <div className="text-sm text-gray-600">
                      <div>{vendor.address || '-'}</div>
                      <div className="flex gap-2 mt-1">
                        <span className="px-2 py-1 text-xs font-semibold rounded" style={{ backgroundColor: '#e8f4fd', color: '#009ef7' }}>
                          {vendor.stateId?.name || '-'}
                        </span>
                        <span className="px-2 py-1 text-xs font-semibold rounded" style={{ backgroundColor: '#e8f4fd', color: '#009ef7' }}>
                          {vendor.countryId?.name || '-'}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-600">{formatDate(vendor.createdAt)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-5 py-8 text-center text-gray-500">
                  No recent vendors found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentVendors;
